// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__+PytG","rotate":"LoadingSpinner_rotate__pkSRF","inside":"LoadingSpinner_inside__22z+M"};